import {
    ApiClientFactory
} from '../ApiClientFactory';
import {
    API_URL,
    API_V4_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const UserClient = {

    /**
     * Returns authenticated user.
     */
    getUserById(userId) {
        return clientFactory.get(API_V4_URL + 'users/' + userId);
    },
    // getUser(withUUID = false) {
    //     return clientFactory.get(API_V4_URL + 'users/me?with[]=roles&with[]=roles.permissions' + (withUUID ? '&with[]=uuid' : ''));
    // },

    /**
     * Returns the classes that user belongs to.
     */
    getClasses() {
        return clientFactory.get('/groups');
    },

    updateUser(user) {
        return clientFactory.put(API_V4_URL + 'users/' + user.id, user);
    },

    /**
     * Creates a new chat between user and ither mentor or program lead.
     *
     * param {data}
     */
    createChat(data) {
        return clientFactory.post(`${API_V4_URL}users/chat`, data);
    },

    setHasLoggedIn() {
        return clientFactory.put(API_V4_URL + 'state')
    },

    updateSplashMeta() {
        return clientFactory.put(API_V4_URL + 'users/meta/splash')
    },
    getProgramLeads() {
        return clientFactory.get(API_V4_URL + 'users/program-leads');
    },

    updateTodo(data) {
        return clientFactory.post(API_URL + 'todos/toggleComplete', data);
    },


}
